import api from './api';

// Hardening 2.4 (2026-08) — Métricas de eficácia da detecção (R7).
// Backend: GET /admin/metrics/efficacy?days=N (baseURL axios já /api/v1).
// Responde "o anti-cheat está funcionando?": FP rate real por event_type,
// funil kicks→bans (auto vs manual), sessões silenciosas/dia, distribuição de
// decisões efetivas, top famílias de eventos e detectores que sumiram.

export interface FpRateRow {
  event_type: string;
  reviewed_fp: number;
  reviewed_ok: number;
  reviewed_total: number;
  fp_rate: number;      // 0..1; 0 quando sem revisões
  unreviewed: number;   // backlog de revisão humana
}

export interface EnforcementFunnel {
  kicks: number;
  ban_temp: number;
  ban_temp_auto: number;    // system:escalation (Hardening 2.1)
  ban_temp_manual: number;
  ban_perm: number;
  ban_perm_auto: number;
  ban_perm_manual: number;
}

export interface SilentDay {
  date: string;   // YYYY-MM-DD (UTC)
  count: number;
}

export interface DecisionCount {
  decision: string;  // ALLOW | FLAG | KICK | BLOCK (efetiva, held-aware)
  count: number;
}

export interface TopEventType {
  event_type: string;
  occurrences: number;
  avg_severity: number;
}

export interface SilentDetector {
  event_type: string;
  last_seen_at: string;        // ISO 8601
  occurrences_before: number;  // volume no período antes do silêncio
  days_silent: number;
}

export interface EfficacyMetrics {
  days: number;          // echo do request (após clamp [1,90] no backend)
  generated_at: string;  // ISO 8601
  fp_rate_by_event_type: FpRateRow[];
  enforcement_funnel: EnforcementFunnel;
  silent_sessions_per_day: SilentDay[];
  decision_distribution: DecisionCount[];
  top_event_types: TopEventType[];
  detector_health: SilentDetector[];
}

export async function getEfficacyMetrics(days = 14): Promise<EfficacyMetrics> {
  const { data } = await api.get<EfficacyMetrics>('/admin/metrics/efficacy', {
    params: { days },
  });
  return data;
}
